import { Component, EventEmitter, Injector, Input, OnChanges, OnDestroy, Output, SimpleChanges, OnInit } from '@angular/core';
import { Checklist } from '../../checklists';
import { BaseComponent } from 'src/app/common/base/base.component';
import { Observable, Subscription } from 'rxjs';
import { ChecklistsRefreshById } from '../../store/checklists/checklists.action';

@Component({
  selector: 'checklist-exec-standalone',
  templateUrl: './checklist-exec-standalone.component.html',
  styleUrls: ['./checklist-exec-standalone.component.scss']
})
export class ChecklistExecStandaloneComponent extends BaseComponent implements OnInit, OnChanges, OnDestroy {

  @Input() currentChecklist?: Checklist;
  @Input() hideToggle?: boolean;
  @Input() disabled?: boolean;

  //@Output() loading = new EventEmitter<any>();

  checklists?: Checklist[];
  checklistsFiltered?: Checklist[];
  checklists$!: Observable<Checklist[]>;
  checklistsSubs!: Subscription;

  expanded = false;

  constructor(
    protected override injector: Injector,
  ) {
    super(injector);
  }

  ngOnInit(): void {
    if (this.currentChecklist) {
      this.store.dispatch(new ChecklistsRefreshById(this.currentChecklist.id));
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.currentChecklist?.id) this.currentChecklist.loading = true;
    this.loadChecklists();
  }

  override ngOnDestroy(): void {
    this.checklistsSubs?.unsubscribe();
  }

  loadChecklists() {
    this.checklists$ = this.store.select(state => state.Checklists.data);
    this.checklistsSubs = this.checklists$.subscribe(data => {
      if (data?.length) {
        this.checklists = data;
        if (this.currentChecklist) {
          const name = this.currentChecklist.name; // Save Checklist name for RSS Functional Tests Checklists
          const checklist = this.checklists.find(c => c.id == this.currentChecklist?.id);
          if (checklist?.id && !checklist?.wfTable) {
            this.store.dispatch(new ChecklistsRefreshById(this.currentChecklist.id));
          }
          else if (checklist) {
            checklist.name = name;
            this.currentChecklist = checklist;
            this.currentChecklist.loading = false;
          }
        }
      }
    });
  }

}
